<template lang="pug">
  nav.sidebar.active
    .sidebar__top
      .sidebar-header
        h3 Ilvaco
        b We make Amazon returns seamless!

      .profile(v-if="user_role === 'client'")
        h4 {{user.name}}
        .balance Balance: {{user.balance}} $

      ul.list-unstyled.components
        li
          router-link(v-if="section_storage"
            :to="{name: ['worker', 'admin'].indexOf(user_role) !== -1 ? 'storage-clients' : 'storage' }"
            :class="{'router-link-active': $route.fullPath.indexOf('/storage') === 0}"
            @click.native="changeSection()",) Storage
          span(v-else) Storage
        li(v-if="user_role === 'admin'")
          router-link(:to="{name: 'billing.valuating' }" @click.native="changeSection()") Billing
        li
          a(href="#", @click="logout") Logout
    .sidebar-footer
      .sidebar-footer__items
        .sidebar-footer__item
          .sidebar-footer__item-title Address
          .sidebar-footer__item-content 5312 Virginia Beach blvd
            br
            | Ste G
          .sidebar-footer__item-content Virginia Beach
          .sidebar-footer__item-content Virginia (VA)
          .sidebar-footer__item-content 23462
        .sidebar-footer__item
          .sidebar-footer__item-title Telephone
          .sidebar-footer__item-content 757-387-9797
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({user: 'ME'}),
    user_role() {
      return this.$store.state.users.role;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    section_storage() {
      return this.$store.state.users.sections.storage;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('LOGOUT');

      this.$router.push({path: '/login'});
    },
    changeSection() {
      this.$store.dispatch('removeClient');
    },
  },
};
</script>

<style lang="stylus" scoped>
.profile
  padding 20px

</style>
